import { GridCol, GridContainer } from '@bob/library'
import ComparisonTable from '@websrc/App/Components/ComparisonTable/ComparisonTable'
import Heading from '@websrc/App/Components/Heading/Heading'
import { mapComparisonTable } from '@websrc/DataMappers/mapSpot'
import { CSSpot_Settings } from '@websrc/Typings/ContentStack'
import { styles } from 'leds'
import React from 'react'

import { LearnMoreButtonType } from '../Collapse/SpotCollapse'
import SelfCollapse from '../SelfCollapse/SelfCollapse'

type SpotComparisonTableProps = {
  spot: ReturnType<typeof mapComparisonTable> & { settings: CSSpot_Settings }
  LearnMoreButton?: LearnMoreButtonType
}

export function SpotComparisonTable({ spot }: SpotComparisonTableProps) {
  return (
    <SelfCollapse collapseSettings={spot.settings.self_collapse}>
      <GridContainer>
        <GridCol>
          <div className={styles({ marginBottom: 50 })}>
            <Heading
              description={spot.description}
              headline={spot.headline}
              label={spot.label}
              level={2}
              size={'xl'}
            />
          </div>
          <ComparisonTable comparisonTable={spot} />
        </GridCol>
      </GridContainer>
    </SelfCollapse>
  )
}
